import {createDetailResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ProductSchema = z.object({
  productName: z.string().nullable(),
  sku: z.string().nullable(),
  description: z.string().nullable(),
  barcode: z.string().nullable(),
  productType: z.string().nullable(),
  purchaseTypeID: z.string().nullable(),
  productSubCategoryID: z.string().nullable(),
  visibilityList: z.array(z.string()).nullable(),
  statusID: z.number(),
  productCategoryID: z.string().nullable(),
  publishDate: z.string().nullable(),
  endDate: z.string().nullable(),
  // image: z.string().nullable(),
  image: z
    .object({
      id: z.string(),
      url: z.string(),
      name: z.string(),
      folder: z.string(),
    })
    .nullable(),
  media: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        folder: z.string(),
        url: z.string(),
      })
    )
    .nullable(),
  price: z.number().nullable(),
  payWithPoints: z.boolean().nullable(),
  eligibleForDiscount: z.boolean().nullable(),
  eligibleForPoints: z.boolean().nullable(),
  approvedProduct: z.boolean().nullable(),
  seasonal: z.boolean().nullable(),
  infoContentData: z.array(z.any()).nullable().optional(),
})

export const ProductSchemaResponse = createDetailResponseSchema(ProductSchema)

export type Product = z.infer<typeof ProductSchema>
export type ProductResponse = z.infer<typeof ProductSchemaResponse>
